/*
 * @Author: yanghailong
 * @Date: 2025-03-27 11:08:33
 * @Last Modified by:   yanghailong
 * @Last Modified time: 2025-03-27 11:08:33
 */



/**
 * 生成随机UUID
 * @returns {String}
 */
export function randomUUID() {
  var d = new Date().getTime()
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16)
  })
  return uuid
}


/**
 * 简易生成hash值
 * @param {string} str
 * @returns {number}
 */
export function hashCode(str) {
  var hash = 0
  for (var i = 0; i < str.length; i++) {
    var char = str.charCodeAt(i)
    hash = ((hash << 5) - hash) + char
    hash |= 0
  }
  return hash
}

/**
 * 将值限制在min和max之间
 * @param {number} min
 * @param {number} max
 * @param {number} value
 * @returns {Number}
 */
export function clamp(min, max, value) {
  return Math.max(min, Math.min(max, value))
}

/**
 * 将source的属性复制到target
 * @param {object} target
 * @param {object} source
 */
export function mixin(target, source) {
  Object.getOwnPropertyNames(source).forEach(prop => {
    if (prop !== 'constructor') {
      Object.defineProperty(target, prop, Object.getOwnPropertyDescriptor(source, prop))
    }
  })
}

/**
 * 列表转化为树形结构
 * @param {Array} data
 * @returns
 */
export function recursiveToTree(data) {
  function loop(key) {
    const arr = []
    data.forEach((item) => {
      if (item.parentId === key) {
        item.children = loop(item.id)
        arr.push(item)
      }
    })
    return arr
  }
  return loop(null)
}



/**
 * 创建单例Class
 * @param {*} className 类
 * @returns
 */
export function createASingletonClass(className) {
  let _instance = null
  return new Proxy(className, {
    construct(target, args) {
      if (!_instance) {
        _instance = new target(...args)
      }
      return _instance
    }
  })
}

/**
 * 将弧度转换为角度
 * @param {number} radian 弧度
 * @returns {number} 角度
 */
export function toDegree(radian) {
  return radian * (180 / Math.PI)
}

/**
 * 将角度转换为弧度
 * @param {number} degree 角度
 * @returns {number} 弧度
 */
export function toRadian(degree) {
  return degree * (Math.PI / 180)
}
